<template>
  <v-layout child-flex row justify-center align-center>

    <v-flex xs12 sm8 md5>
      <div class="display-2 text-xs-center">
        <div>
          <v-icon color="error mb-4" size="200px">error_outline</v-icon>
        </div>
        <div>{{ $t('errori.pagina_non_disponibile') }}</div>
      </div>
    </v-flex>

  </v-layout>
</template>
<script>
export default {
    name: 'NotFound'
}
</script>
